import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {},
  testRoot: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  testSkeleton: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  testUnitName: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: 'background.paper',
    borderRadius: 1,
  },
  testUnitSize: {
    marginBottom: theme.spacing(1),
  },
}));
